import "./KnowledgeHub.module.css";
import Header from "@/reusable_sections/Header";
import EssentialReading from "./sections/EssentialReading";
import TheFullArchive from "./sections/TheFullArchive";
import Footer from "@/reusable_sections/Footer";
export default function KnowledgeHubPage() {
  return <div>
      <Header />
      <EssentialReading />
      <TheFullArchive />
      <Footer />
    </div>;
}